import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;

export const InfoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const HelpText = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 12px;
  background-color: ${({ theme }) => theme.warning}10;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.warning}30;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
